/**
 * Libellés courts pour les parcours d’auth publics (client, tiers).
 * Formulations utilisables sans lien d’invitation dans l’URL.
 */
import { organizationSubject } from "@Front/Utils/publicSiteBranding";

export const PUBLIC_AUTH_ACCOUNT_NOT_FOUND_MESSAGE =
	"Votre compte n'a pas été trouvé. Vérifiez votre adresse e-mail.";

/** Plusieurs dossiers / offices possibles pour le même e-mail ; scope insuffisant pour en choisir un. */
export const PUBLIC_AUTH_AMBIGUOUS_ACCESS_MESSAGE =
	`Plusieurs accès correspondent à cet e-mail. Vérifiez votre saisie ou contactez ${organizationSubject()} qui vous accompagne.`;

/** Réponse API « client + tiers » sans étape UI (erreur). */
export const PUBLIC_AUTH_EMAIL_ACTOR_CHOICE_MESSAGE =
	"Cet e-mail permet un accès client et un accès tiers. Rechargez la page pour choisir l'espace.";

/** Dossier connu mais non autorisé pour ce tiers / cet e-mail. */
export const PUBLIC_AUTH_FOLDER_NOT_ACCESSIBLE_MESSAGE =
	"Accès à ce dossier impossible. Vérifiez votre adresse e-mail.";
